'use strict';

var util = require('./util');

module.exports = SchemaObject;

function SchemaObject(obj) {
  util.copy(obj, this);
}



//////////////////
// WEBPACK FOOTER
// ./~/ajv/lib/compile/schema_obj.js
// module id = 109
// module chunks = 1